module.exports = __webpack_public_path__ + "static/admareLogo-02eac7c828eecde10ee29a6201a463c3.png";